export default __webpack_public_path__ + "static/media/overpay.8bb844e7.svg";